var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("BreaksConfirmation", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h3",
              {
                directives: [
                  {
                    name: "data-cy",
                    rawName: "v-data-cy",
                    value: "schedule-rest-break-header",
                    expression: "'schedule-rest-break-header'",
                  },
                ],
              },
              [_vm._v("\n\t\t\tSchedule rest break\n\t\t")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "bodyIcon",
        fn: function () {
          return [
            _c("OrigamiIcon", {
              staticClass: "tw-text-origami-grey-400",
              attrs: { name: "schedule", width: "32", height: "32" },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "bodyText",
        fn: function () {
          return [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "data-cy",
                    rawName: "v-data-cy",
                    value: "start-time-body-text",
                    expression: "'start-time-body-text'",
                  },
                ],
                staticClass: "tw-text-left tw-mb-1 tw-text-xs",
              },
              [_vm._v("\n\t\t\tStart time\n\t\t")]
            ),
            _vm._v(" "),
            _c("BreakRequestTimeDropdown", {
              attrs: {
                "min-start-time": _vm.minStartTime,
                "max-start-time": _vm.maxStartTime,
              },
              on: { "select-time-block": _vm.handleSelectedTime },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "buttons",
        fn: function () {
          return [
            _c(
              "OrigamiButton",
              {
                directives: [
                  {
                    name: "jest",
                    rawName: "v-jest",
                    value: "cancel-rest-break-button",
                    expression: "'cancel-rest-break-button'",
                  },
                  {
                    name: "data-cy",
                    rawName: "v-data-cy",
                    value: "cancel-rest-break-button",
                    expression: "'cancel-rest-break-button'",
                  },
                ],
                staticClass: "tw-m-auto tw-mb-2 tw-w-full tw-justify-center",
                attrs: { variant: "secondary" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.cancelRestBreak.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n\t\t\tCancel\n\t\t")]
            ),
            _vm._v(" "),
            _c(
              "OrigamiButton",
              {
                directives: [
                  {
                    name: "jest",
                    rawName: "v-jest",
                    value: "schedule-rest-break-button",
                    expression: "'schedule-rest-break-button'",
                  },
                  {
                    name: "data-cy",
                    rawName: "v-data-cy",
                    value: "schedule-rest-break-button",
                    expression: "'schedule-rest-break-button'",
                  },
                ],
                staticClass: "tw-mb-2 tw-w-full tw-justify-center",
                attrs: {
                  variant: "primary",
                  "is-loading":
                    _vm.$store.state.BreaksManagementWidget.isRequestLoading,
                  disabled: !_vm.selectedTimeBlock,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.requestRestBreak.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n\t\t\tSchedule for later\n\t\t")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }